export const state = () => ({
    //
});

export const mutations = {
    //
};

export const getters = {
    //
};

export const actions = {
    create(state: any, payload: any) {
        const company_uuid = this.$auth.user.company.uuid;

        return new Promise((resolve, reject) => {
            this.$axios
                .post(`/api/company/${company_uuid}/bursaries`, payload)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    update(state: any, payload: any) {
        const { uuid, ...data } = payload;

        return new Promise((resolve, reject) => {
            this.$axios
                .put(`/api/bursaries/${uuid}`, data)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};
